import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { CheckCircleOutline } from '@material-ui/icons';
import { green } from '@avangard/ui/colors';

type TotpConnectInfoProps = {
    type: 'connected' | 'disconnected';
};

const Root = styled.div`
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;

    & > *:not(:last-child) {
        margin-bottom: 8px;
    }
`;

const checkIcon = <CheckCircleOutline style={{ fontSize: 42, color: green[100] }} />;

const TotpConnectInfo = (props: TotpConnectInfoProps): React.ReactElement => {
    const { type } = props;

    const { t } = useTranslation('auth');

    if (type === 'disconnected') {
        return (
            <Root>
                <span>{checkIcon}</span>
                <b>{t('auth:blocks.totp.connect_info.disconnected.title')}</b>
                <p>{t('auth:blocks.totp.connect_info.disconnected.description')}</p>
            </Root>
        );
    }

    return (
        <Root>
            <span>{checkIcon}</span>
            <b>{t('auth:blocks.totp.connect_info.connected.title')}</b>
            <p>{t('auth:blocks.totp.connect_info.connected.description')}</p>
        </Root>
    );
};

export { TotpConnectInfo };
